export default "__VITE_ASSET__DyzESWjm__"